module.exports = __webpack_public_path__ + "img/02-settings.7ed8b7b4.png";